"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var widget_helpers_1 = require("../util/widget-helpers");
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelect = function () {
            if (!_this.props.disabled) {
                widget_helpers_1.notify(_this.props.onSelect, _this.props.dataItem);
            }
        };
        _this.handleArrowKeys = function (evt) {
            var next = evt.target.nextElementSibling;
            var prev = evt.target.previousElementSibling;
            if (evt.keyCode === 39) {
                if (next && next.tabIndex !== -1) {
                    next.focus();
                }
                else if (next && next.tabIndex === -1) {
                    next.nextElementSibling && next.nextElementSibling.focus();
                }
            }
            if (evt.keyCode === 37) {
                if (prev && prev.tabIndex !== -1) {
                    prev.focus();
                }
                else if (prev && prev.tabIndex === -1) {
                    prev.previousElementSibling && prev.previousElementSibling.focus();
                }
            }
        };
        return _this;
    }
    Tab.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, children = _b.children, focused = _b.focused, selected = _b.selected, disabled = _b.disabled, role = _b.role, orientation = _b.orientation;
        var otherProps = _1.omit(this.props, Object.keys(Tab.propTypes));
        var tabClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('tab')] = true,
            _a[vdl_prefix_1.vdlPrefix('tab--focus')] = focused,
            _a[vdl_prefix_1.vdlPrefix('tab--selected')] = selected,
            _a[vdl_prefix_1.vdlPrefix('tab--disabled')] = disabled,
            _a[vdl_prefix_1.vdlPrefix('tab--' + orientation)] = true,
            _a);
        return (React.createElement("li", __assign({}, otherProps, { role: role, tabIndex: disabled ? -1 : this.props.index, "aria-selected": !!selected, onFocus: this.onSelect, onKeyDown: this.handleArrowKeys, className: classnames_1.classNames(className, tabClasses), onClick: this.onSelect }),
            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('tab__content') }, children)));
    };
    Tab.propTypes = {
        dataItem: PropTypes.any,
        selected: PropTypes.bool,
        focused: PropTypes.bool,
        disabled: PropTypes.bool,
        children: PropTypes.node,
        className: PropTypes.string,
        role: PropTypes.string,
        orientation: PropTypes.oneOf(['horizontal', 'vertical']),
        onSelect: PropTypes.func,
        index: PropTypes.number
    };
    Tab.defaultProps = {
        role: 'tab',
        orientation: 'horizontal',
        index: 0
    };
    return Tab;
}(React.Component));
exports.Tab = Tab;
